export default __webpack_public_path__ + "static/media/work.ed61dfb6.svg";